import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Transformation } from '../components/Transformation';
import { Method } from '../components/Method';
import { WhyOthersFail } from '../components/WhyOthersFail';
import { Story } from '../components/Story';
import { Testimonials } from '../components/Testimonials';
import { PurchaseSection } from '../components/PurchaseSection';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { MobileOfferBanner } from '../components/MobileOfferBanner';
export function LandingPage() {
  return <>
      <main className="min-h-screen w-full overflow-x-hidden" data-id="element-603">
        <Hero data-id="element-604" />
        <PainPoints data-id="element-605" />
        <Transformation data-id="element-606" />
        <Method data-id="element-607" />
        <WhyOthersFail data-id="element-608" />
        <Story data-id="element-609" />
        <Testimonials data-id="element-610" />
        <PurchaseSection data-id="element-611" />
        <FAQ data-id="element-612" />
        <FinalCTA data-id="element-613" />
        <Footer data-id="element-614" />
      </main>
      <PurchaseNotification data-id="element-615" />
      <MobileOfferBanner data-id="element-616" />
    </>;
}